import { Box, Grid } from "@mui/material";
import { Navigate } from "react-router";

import { theme } from "@covertree/theme";
import { TotalChange } from "./TotalChange";
import { EffectiveDate } from "./EffectiveDate";
import { useSummaryTable } from "./useSummaryTable";
import { type PremiumDeltaDirection } from "@utils/formatPremiumDelta";

const TOTAL_LABEL: Record<PremiumDeltaDirection, string> = {
  increase: "Additional Premium",
  decrease: "Return Premium",
  none: "No premium change",
};

export const SummaryTable = () => {
  const { redirectTo, effectiveDate, total, premium, tax, fees } =
    useSummaryTable();

  if (redirectTo) {
    return <Navigate to={redirectTo} replace />;
  }

  return (
    <Box
      sx={{
        borderRadius: theme.spacing(2),
        border: `1px solid ${theme.palette.divider}`,
        paddingY: theme.spacing(3),
        paddingX: theme.spacing(3.5),
        backgroundColor: theme.palette.grey[100],
      }}>
      <Grid container display="flex">
        <Grid item flexGrow={1}>
          <EffectiveDate effectiveDate={effectiveDate} />
        </Grid>
        <Grid
          item
          sx={{
            backgroundColor: theme.palette.divider,
            width: "1px",
            marginX: theme.spacing(3),
          }}></Grid>
        <Grid item flexGrow={1}>
          <TotalChange
            total={total.text}
            totalColor={total.color}
            totalLabel={TOTAL_LABEL[total.direction]}
            isTotalChanged={total.direction !== "none"}
            premium={premium}
            tax={tax}
            fees={fees}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
